import React from "react";
import AntdCascader, {CascaderProps} from 'antd/lib/cascader';
import {withError} from '@fishx/tracker';

interface FNCascaderProps extends CascaderProps{
  forwardedRef?: any;

}
export const Cascader: React.FC<FNCascaderProps> =(props) => {
  const {forwardedRef, ...rest} = props;
    return (
      <AntdCascader {...rest} ref ={forwardedRef}/>
    )
};
Cascader.displayName = 'Cascader'
export default withError(Cascader,{
  forwardRef: true,
});




// WEBPACK FOOTER //
// ./src/components/cascader/index.tsx